//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObjectCollection.js";
import "../no/SmartObject.js";
import "../no/ugmath.js";
import "../no/BasePart.js";
let d=[[],[[["origin","orientation","is_temporary"],"CreateCoordinateSystem",{R_:{cs:"CartesianCoordinateSystem"}},3,0],[["origin","x_direction","y_direction"],"CreateCoordinateSystem1",{R_:{cs:"CartesianCoordinateSystem"}},3,0],[["origin","x_direction","y_direction"],"CreateCylindricalCoordinateSystem",{R_:{cs:"CylindricalCoordinateSystem"}},3,0],[["origin","x_direction","y_direction"],"CreateSphericalCoordinateSystem",{R_:{cs:"SphericalCoordinateSystem"}},3,0],[["origin","orientation","is_temporary"],"CreateCoordinateSystemUsingNxmatrix",{R_:{cs:"CartesianCoordinateSystem"}},3,0],[["xform","update"],"CreateCoordinateSystemUsingXform",{R_:{cs:"CartesianCoordinateSystem"}},2,0],[["origin","orientation","is_temporary"],"CreateCylindricalCoordinateSystemUsingNxmatrix",{R_:{cs:"CylindricalCoordinateSystem"}},3,0],[["xform","update"],"CreateCylindricalCoordinateSystemUsingXform",{R_:{cs:"CylindricalCoordinateSystem"}},2,0],[["origin","orientation","is_temporary"],"CreateSphericalCoordinateSystemUsingNxmatrix",{R_:{cs:"SphericalCoordinateSystem"}},3,0],[["xform","update"],"CreateSphericalCoordinateSystemUsingXform",{R_:{cs:"SphericalCoordinateSystem"}},2,0],[["csystem","origin","direction1","direction2"],"GetOriginAndDirections",{},1,0]],[]];
SPLM.CoordinateSystemCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CoordinateSystemCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;